import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { QUERY_KEYS } from '../constants';
import { Timesheet, UserRole } from '../../types';

async function fetchTimesheets(id: number, role?: UserRole): Promise<Timesheet[]> {
  const params = new URLSearchParams();
  if (role) params.append('role', role);
  const query = params.toString();
  const { data } = await Http.axios.get<Timesheet[]>(
    `/timesheet/user/${id}${query ? `?${query}` : ''}`
  );
  return data;
}

export const useTimesheets = ({ userId, role }: { userId?: number; role?: UserRole }) => {
  return useQuery([QUERY_KEYS.TIMESHEETS, userId, role], () => fetchTimesheets(userId as number, role), {
    staleTime: Infinity,
    enabled: !!userId,
    refetchInterval: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
  });
};

export const useInvalidateTimesheets = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.TIMESHEETS,
    });
  };
};
